// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_shoes_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Walk, stand, and move on air. Every pair features the patented air cushion sole.`
};

const el_tech_shoes_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Περπατήστε, σταθείτε και κινηθείτε στον αέρα. Κάθε ζευγάρι διαθέτει την πατενταρισμένη σόλα αερόστρωμα.`
};

const ru_tech_shoes_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Ходите, стойте и двигайтесь на воздухе. Каждая пара оснащена запатентованной подошвой с воздушной подушкой.`
};

const he_tech_shoes_desc = /** @type {(inputs: {}) => string} */ () => {
	return `הלכו, עמדו וזזו על אוויר. כל זוג כולל את סוליית כרית האוויר המוגנת בפטנט.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_shoes_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_shoes_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_shoes_desc", locale)
	if (locale === "en") return en_tech_shoes_desc(inputs)
	if (locale === "el") return el_tech_shoes_desc(inputs)
	if (locale === "ru") return ru_tech_shoes_desc(inputs)
	if (locale === "he") return he_tech_shoes_desc(inputs)
	return "tech_shoes_desc"
};